/** Environnements possibles de MYFACTORY */
export enum EEnvironmentName{
    DEV    = 'DEV'  ,
    DEMO   = 'DEMO' ,
    PROD   = 'PROD' ,
}